import request from '@/utils/seftRequest';

// 查询代理商员工充值列表 /drm/ding/etopup/qryEnumberList4Staff/{staffId}
export function qryEnumberList4Staff(staffId) {
  return request(`/ding/etopup/qryEnumberList4Staff/${staffId}`);
}

// 查询代理商ENumber余额 /drm/ding/etopup/agentEvoucherQry
export function agentEvoucherQry(params) {
  return request('/ding/etopup/agentEvoucherQry', { params });
}

// 查询当前订户号码的欠费信息 drm/ding/custService/queryAccountBsnl
export function queryAccountBsnl(params) {
  return request('/ding/custService/queryAccountBsnl', { params });
}

// 历史账单查询 drm/ding/custService/queryHisBillBsnl
export function queryHisBillBsnl(data) {
  return request('/ding/custService/queryHisBillBsnl', {
    method: 'POST',
    body: data,
  });
}

// 缴费接口 /drm/ding/custService/recharge4User
export function recharge4User(data) {
  return request('/ding/custService/recharge4User', {
    method: 'POST',
    body: data,
  });
}

// 充值历史查询 /drm/ding/custService/queryRechargeHisBsnl
export function queryRechargeHisBsnl(data) {
  return request('/ding/custService/queryRechargeHisBsnl', {
    method: 'POST',
    body: data,
  });
}

// 代理商在自服务给终端客户缴账生成ETC的requestId查询 /drm/ding/custService/etc/request-id
export function queryrequestId() {
  return request('/ding/custService/etc/request-id', {
    method: 'POST',
  });
}

// 代理商在自服务给终端客户缴账是否需要发送验证码 /drm/ding/otp/checkStaffOtpFlag
export function checkStaffOtpFlag(data) {
  return request('/ding/otp/checkStaffOtpFlag', {
    method: 'POST',
    body: data,
  });
}
